package data.models

import kotlinx.serialization.Serializable

@Serializable
data class OtpData(
    val email: String,
    val code: String?,
)


